import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortIconPipe } from './sort-icon.pipe';

@NgModule({
  declarations: [SortIconPipe],
  imports: [CommonModule],
  exports: [SortIconPipe]
})
export class SortIconPipeModule {}
